/**
 * an async take of the setTimeout function.
 * @param {number} delay in milliseconds
 * @return {Promise} when timer is finished
 *
 * @example `
 *  await timeout(2000);
 *  doSomethingAfter2Sec();
 * `
 */
const timeout = function (delay) {
  return new Promise((resolve) => {
    const intervalId = setInterval(function () {
      clearInterval(intervalId);
      resolve(null);
    }, delay);
  });
};

export default timeout;
